import React from "react";
import BarChart from "../../../components/BarChart/BarChart";

const ZiekenhuizenKlinieken = () => {
	const formatValueTooltip = val => val + " instellingen";
	const formatValueY = val => val;

	const data = [
		{ key: "Algemene ziekenhuizen", value: 81 },
		{ key: "Universitair Medische Centra", value: 8 },
		{ key: "Gespecialiseerde klinieken", value: 65 },
		{ key: "Privéklinieken (zbc's)", value: 231 }
	];

	return (
		<div className="vis-ziekenhuizen-klinieken">
			<BarChart
				data={data}
				margin={{ top: 30, right: 0, bottom: 10, left: 239 }}
				barHeight={30}
				domain={[0, 231]}
				color={{ fill: "#333", stroke: "#fff" }}
				formatValueTooltip={formatValueTooltip}
				formatValueY={formatValueY}
				padding={0.2}
				ticks={0}
			/>

			<div className="vis-credit">
				<p>Aantal instellingen voor medisch specialistische zorg in 2015</p>
				<p>Bron: Nederlandse Zorgautoriteit</p>
			</div>
		</div>
	);
};

export default ZiekenhuizenKlinieken;
